import { config } from '@fortawesome/fontawesome-svg-core'
import '@fortawesome/fontawesome-svg-core/styles.css'

import "./src/styles/global.scss"

config.autoAddCss = false